// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__pFDlL","colMaxWidth":"Table_colMaxWidth__21oZh"};